import { GiftCodeDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Badge } from "@babackapp/ui/components/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@babackapp/ui/components/tooltip";

type GiftCodeCellProps = {
  giftCode: GiftCodeDto;
};

// Codes of the same line item, minted by concurrent calls (BBS-376): only one
// of them can be redeemed, so both rows show the same usage.
export default function GiftCodeCell({ giftCode }: GiftCodeCellProps) {
  const t = useTranslation();
  const linkedGiftCodes = giftCode.linkedGiftCodes ?? [];

  return (
    <div className="flex items-center gap-2">
      <Badge variant="outline">{giftCode.giftCode}</Badge>
      {linkedGiftCodes.length > 0 && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge variant="secondary">{t("giftCodes.duplicate.badge")}</Badge>
          </TooltipTrigger>
          <TooltipContent>
            {t("giftCodes.duplicate.tooltip", {
              codes: linkedGiftCodes.join(", "),
            })}
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
}
